var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import NumberRange from "~/components/common/number-range.vue";
import { PageService } from "~/utils/page.service";
import { State } from "vuex-class";
import { CaseInfoService } from "../../services/domain-service/case-info.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import PrincipalRecovery from "~/components/apply-component/principal-recovery.vue";
var AllocatedCase = /** @class */ (function (_super) {
    __extends(AllocatedCase, _super);
    function AllocatedCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.importModel = {
            principalId: "",
            batchNumber: "",
            mobileNo: "",
            personalName: "",
            amountRange: { min: "", max: "" },
            caseNumber: '',
            principalName: '',
            partnerName: '',
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            idCard: '',
            loanDate: [],
            dataFromSource: '',
            overdueDays: {
                max: "",
                min: ""
            },
            compensationMoney: {
                max: "",
                min: ""
            }
        };
        // 表单验证规则
        _this.allocatedRule = {
            mobileNo: [
                {
                    validator: _this.$validator.phoneNumber,
                    trigger: "blur"
                }
            ]
        };
        _this.importDataSet = [];
        _this.selectionList = [];
        _this.caseDetail = {};
        _this.dialog = {
            allocate: false,
            batchAllocate: false,
            caseNumber: '',
            principalRecovery: false
        };
        _this.allocateModel = {
            caseIds: [],
            distributeTypeList: [],
            partCollectionDays: ''
        };
        _this.batchAllocateModel = {
            operateType: 'divisional',
            distributeTypeList: [],
            partCollectionDays: ''
        };
        // 接口最初返回的案件池类型，用于确认时对比
        _this.originalTypes = [];
        _this.submitLoading = false;
        return _this;
    }
    /**
     * 获取已分配案件
     */
    AllocatedCase.prototype.refreshData = function () {
        var _this = this;
        this.CaseInfoService.getAllAllocatedCaseInfos(this.importModel, this.pageService).subscribe(function (data) {
            _this.importDataSet = data;
            _this.selectionList = [];
        });
    };
    AllocatedCase.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * 重置numberRange
     */
    AllocatedCase.prototype.follFeedback = function () {
        this.importModel.amountRange = { min: "", max: "" };
        this.importModel.dayRange = { min: "", max: "" };
        this.importModel.rateRange = { min: "", max: "" };
        this.importModel.caseMoney = { min: "", max: "" };
        this.importModel.compensationMoney = { min: "", max: "" };
        this.importModel.overdueDays = { min: "", max: "" };
    };
    /**
     * 分案类型转化为中文展示，最多展示三个，逗号分隔
     */
    AllocatedCase.prototype.formatDepartmentTypes = function (list) {
        if (list === void 0) { list = []; }
        var map = { TEL: "电催", VISIT: "外访", LEGAL: "法催" };
        if (!Array.isArray(list))
            return "";
        return list.slice(0, 3).map(function (item) { return map[item] || item; }).join("，");
    };
    /**
     * 进入查看执行页
     */
    AllocatedCase.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Case_await,
            hiddenCaseList: true,
            hiddenAction: true,
            hiddenCollectionStatus: true
        });
    };
    /**
     * 导出案件
     */
    AllocatedCase.prototype.exportCaseInfo = function () {
        var _this = this;
        var ids = this.selectionList.map(function (v) { return v.id; });
        var request = __assign(__assign({}, this.importModel), { caseIds: ids });
        this.CaseInfoService
            .allocatedCaseInfosExport(request)
            .subscribe(function (data) { return _this.$common.downloadFile(data.url); });
    };
    /**
     * 打开分配弹框，查询当前案件池类型并回显勾选
     */
    AllocatedCase.prototype.openAllocate = function (row) {
        var _this = this;
        this.originalTypes = [];
        this.dialog.caseNumber = row.caseNumber;
        this.allocateModel = {
            caseIds: [row.id],
            distributeTypeList: [],
            partCollectionDays: ''
        };
        this.CaseInfoService.getAllocatedCaseTypeList({ id: row.id })
            .subscribe(function (data) {
            var list = (data && Array.isArray(data)) ? data : [];
            // 记忆最初接口返回的值
            _this.originalTypes = __spreadArrays(list);
            _this.allocateModel.distributeTypeList = __spreadArrays(list);
            _this.dialog.allocate = true;
        });
    };
    /**
     * 打开批量分案弹框
     */
    AllocatedCase.prototype.openBatchAllocate = function () {
        if (this.selectionList.length === 0) {
            this.$message("\u8BF7\u9009\u62E9\u8981\u6279\u91CF\u5206\u6848\u7684\u6848\u4EF6");
            return;
        }
        this.batchAllocateModel = {
            operateType: 'divisional',
            distributeTypeList: [],
            partCollectionDays: ''
        };
        this.dialog.batchAllocate = true;
    };
    /**
     * 提交批量操作：分案新增类型 / 撤销类型
     */
    AllocatedCase.prototype.submitBatchAllocate = function () {
        var _this = this;
        if (this.batchAllocateModel.distributeTypeList.length === 0) {
            this.$message("\u8BF7\u9009\u62E9\u81F3\u5C11\u4E00\u4E2A\u50AC\u6536\u7C7B\u578B");
            return;
        }
        var caseIds = this.selectionList.map(function (v) { return v.id; });
        var isRevocation = this.batchAllocateModel.operateType === 'revocation';
        this.submitLoading = true;
        this.CaseInfoService.batchAddDistributeType({
            caseIds: caseIds,
            distributeTypeList: this.batchAllocateModel.distributeTypeList,
            operateType: this.batchAllocateModel.operateType,
            partCollectionDays: this.batchAllocateModel.partCollectionDays
        }).subscribe(function () {
            _this.submitLoading = false;
            _this.dialog.batchAllocate = false;
            _this.refreshData();
            _this.$message.success(isRevocation ? '批量撤销成功' : '批量分案成功');
        }, function () {
            _this.submitLoading = false;
        });
    };
    Object.defineProperty(AllocatedCase.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 委托方回收
     */
    AllocatedCase.prototype.dealManualPartReturnCase = function () {
        if (this.selectionList.length !== 0) {
            this.dialog.principalRecovery = true;
        }
        else {
            this.$message("\u8BF7\u9009\u62E9\u8981\u8FDB\u884C\u59D4\u6258\u65B9\u56DE\u6536\u7684\u6848\u4EF6");
        }
    };
    /**
     * 确认分配：与最初接口返回值对比，相同则不调用接口，不同则调分案接口
     */
    AllocatedCase.prototype.submitAllocate = function () {
        var _this = this;
        var current = __spreadArrays(this.allocateModel.distributeTypeList).sort();
        var origin = __spreadArrays(this.originalTypes).sort();
        // 忽略顺序对比
        if (JSON.stringify(current) === JSON.stringify(origin)) {
            this.$message.info('案件池未发生变化');
            this.dialog.allocate = false;
            return;
        }
        this.submitLoading = true;
        this.CaseInfoService
            .redistributionCaseInfo({
            caseId: this.allocateModel.caseIds[0],
            distributeTypeList: this.allocateModel.distributeTypeList,
            partCollectionDays: this.allocateModel.partCollectionDays
        })
            .subscribe(function () {
            _this.submitLoading = false;
            _this.dialog.allocate = false;
            _this.refreshData();
        }, function () {
            _this.submitLoading = false;
        });
    };
    __decorate([
        State
    ], AllocatedCase.prototype, "principalList", void 0);
    __decorate([
        Dependencies(PageService)
    ], AllocatedCase.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseInfoService)
    ], AllocatedCase.prototype, "CaseInfoService", void 0);
    AllocatedCase = __decorate([
        Auth(101),
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange,
                PrincipalRecovery: PrincipalRecovery
            }
        })
    ], AllocatedCase);
    return AllocatedCase;
}(Vue));
export default AllocatedCase;
